export const COURSE_PAYMENT_URLS = {
  ski: "https://www.skiwork.shop/IT/PIN72U65/collettive/119",
  snow: "https://www.skiwork.shop/IT/PIN72U65/collettive/120",
} as const;
